import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModuleNgFactory } from '../aot/src/app/app.module.ngfactory';
import { KeycloakService } from './app/services/keycloak.service';
enableProdMode();
//console.log('Running AOT compiled');
var url = window.location.href;
//console.log("main-aot");
//console.log("url: " + url);
var blockedUrls = ['/actuacion', '/enlace-no-autorizado', '/vinculacion-rep', '/desvinculacion-rep'];
if (blockedUrls.every(function (urlBlock) { return !url.includes(urlBlock); })) {
    //console.log("entra en if main-aot");
    if (url.indexOf("search") !== -1) {
        window.location.href = url.substring(0, url.indexOf("search"));
    }
    KeycloakService.init().then(function () {
        platformBrowser().bootstrapModuleFactory(AppModuleNgFactory);
    }).catch(function () {
        //console.log("Error en autenticación ...");
        window.location.reload();
    });
}
else {
    //console.log("entra al else main-aot");
    platformBrowser().bootstrapModuleFactory(AppModuleNgFactory);
}
//# sourceMappingURL=main-aot.js.map